import { store } from '../redux';
import { setOnlineStatus } from '../redux/sync.slice';

// Check connection interval in ms (15 seconds)
const CHECK_INTERVAL = 15000;

export const initNetworkListener = () => {
  // Initial online status
  updateOnlineStatus();

  // Listen for online/offline events
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  // Periodically check connection
  setInterval(updateOnlineStatus, CHECK_INTERVAL);
};

const handleOnline = async () => {
  const isReally = await checkConnection();
  if (isReally) {
    store.dispatch(setOnlineStatus(true));
  }
};

const handleOffline = () => {
  store.dispatch(setOnlineStatus(false));
};

const updateOnlineStatus = async () => {
  const previousStatus = store.getState().sync.isOnline;
  const isOnline = await checkConnection();
  
  // Only dispatch if the status changed to avoid unnecessary renders
  if (previousStatus !== isOnline) {
    store.dispatch(setOnlineStatus(isOnline));
  }
};

export const checkConnection = (): Promise<boolean> => {
  return new Promise((resolve) => {
    // Try to fetch a small resource to verify internet connection
    fetch('/favicon.ico', { 
      method: 'HEAD',
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(response => resolve(response.ok))
      .catch(() => resolve(false));
  });
};
